<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: null,
    },
  },
}
</script>

<template>
  <button
    :class="[
      $style.button,
      { [$style.active]: active },
      { [$style.inactive]: active === false },
    ]"
  >
    <slot />
  </button>
</template>

<style lang="scss" module>
@import '@design';

.button {
  @extend %typography-small;

  padding: $size-button-padding;
  color: $color-button-text;
  cursor: pointer;
  background: $color-button-bg;
  border: none;
  transition: all 0.3s;

  &.inactive {
    background: $color-button-inactive-bg;
  }

  &.active {
    z-index: $layer-page-z-index;
    background: $color-button-active-bg;
    outline: none;
    box-shadow:
      0 -1px 0 $color-button-active-bg,
      0 1px 0 $color-button-active-bg;
  }

  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }
}
</style>
